import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('syenovix_token');
    const email = localStorage.getItem('syenovix_email');
    if (token && email) setUser({ email });
    setLoading(false);
  }, []);

  async function login(email, password) {
    const { token } = await api.login(email, password);
    localStorage.setItem('syenovix_token', token);
    localStorage.setItem('syenovix_email', email);
    setUser({ email });
  }

  function logout() {
    localStorage.removeItem('syenovix_token');
    localStorage.removeItem('syenovix_email');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
